/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import VsiProductBadges, { badgePageType } from '../../themes/dobbies/utilities/badges/vsi-product-badges';

import { IMediaGalleryThumbnailItemViewProps, IMediaGalleryThumbnailsViewProps } from '@msdyn365-commerce-modules/media-gallery';
import { IMediaGalleryViewProps } from './dobbies-media-gallery';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { CarouselProps, Thumbnails, MediaGallery, Modal } = props;
    let productAvailbilityData;
    if (props.data) {
        productAvailbilityData = props.data.productAvailableQuantity;
    }
    return (
        <Module {...MediaGallery}>
            <Node tag='div' className='position-relative order-one'>
                <Node {...CarouselProps} />
                <VsiProductBadges
                    mediaGalleryProduct={props.data.product.result}
                    context={props.context}
                    moduleType={badgePageType.pdp}
                    productAvailableData={productAvailbilityData}
                />
            </Node>
            {Modal}
            {_renderThumbnails(Thumbnails)}
        </Module>
    );
};

const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
    const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;

    return (
        <Node {...ThumbnailsContainerProps}>
            <Node {...SingleSlideCarouselComponentProps}>{items && items.map(_renderThumbnailItem)}</Node>
        </Node>
    );
};

const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
    const { ThumbnailItemContainerProps, Picture } = thumbnail;

    return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
};

export default MediaGalleryView;
